import { useEffect, useState } from 'react';
import MotionImagesWithScroll from '../motionImagesWithScroll/MotionImagesWithScroll';
import './home.css';
import { homeGhajari3TopTemplate } from '../template/homeGhajari3TopTemplate';
import { homeGhajari3AboutTemplate } from '../template/homeGhajari3AboutTemplate';
import PlatformMajAnimationLogo from '../platformMaj/platformMajAnimationLogo';
import PlatformMajPictureZoom from '../platformMaj/platformMajPictureZoom';
import ContactUs from './ContactUs';
import Footer from './Footer';
import Education from '../education/Education';
import { Box } from '@mui/material';
import BeyondCode from '../platformMaj/BeyondCode';
import Experience from '../showExperienceWithScroll/Experience';

const Home: React.FC = () => {
  const [scrollY, setScrollY] = useState<number>(window.scrollY);
  const [windowSize, setWindowSize] = useState<{ width: number; height: number }>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    const handleResize = () => setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Box >

      <MotionImagesWithScroll
        id='majidTemplate'
        folder='majidTemplate'
        length={51}
        distance={50}
        fileFormat='.jpg'
        fullScreen={true}
        scrollY={scrollY}
        windowSize={windowSize}
        header="Majid Ghajari"
        description="Senior web developer"
      />

      <PlatformMajAnimationLogo
        item={homeGhajari3TopTemplate}
        scrollY={scrollY}
        windowSize={windowSize}
      />

      <PlatformMajPictureZoom
        item={homeGhajari3AboutTemplate}
        scrollY={scrollY}
        windowSize={windowSize}
      />

      <Experience
        scrollY={scrollY}
        windowSize={windowSize}
      />

      <Education />

      {/* <PlatformMajMovePictures
        windowSize={windowSize}
      /> */}

      <BeyondCode windowSize={windowSize} />

      <ContactUs />

      <Footer />
    </Box>
  );
};

export default Home;